import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { BrowserRouter } from 'react-router-dom';
import { BUIProvider } from '@bookingcom/bui-react';
import legacyTheme from '@bookingcom/bui-react/themes/legacy';
import ErrorBoundary from './components/errorBoundary/ErrorBoundary';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <BUIProvider theme={legacyTheme}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BUIProvider>
    </BrowserRouter>
  </StrictMode>
);
